//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class ExportRuleModel extends ModelBase {
      static readonly $typeName = 'ExportRuleModel';
      public collectionName: string;
      public moduleName: string;
      public ruleName: string;
      public status: string;
      public comparisonDate: string;
      public effectiveDate: string;
      public expirationDate: string;
      public url: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/ExportRuleModel.ts